<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="main-card-body">
        <div class="body-header d-flex">
          <div class="header-title">
            <h4 class="card-header-title">Cấu hình nghỉ phép nhân viên</h4>
          </div>
          
          <div class="text-right year-toolbar-wrap">
            <el-form
              ref="yearForm"
              label-position="left"
              label-width="50px"
              :model="mData.dataForm"
              
            >
              <el-form-item label="Năm">
                <el-date-picker
                  class="year"
                  v-model="mData.dataForm.curentYear"
                  type="year"
                  :default-value="new Date()"
                  :clearable="false"
                  :editable="false"
                  format="yyyy"
                  value-format="yyyy"
                  @change="fn_searchYear"
                >
                </el-date-picker>
              </el-form-item>
            </el-form>
          </div>
          <div class="header-actions">
            <el-button
              v-if="mData.canManageAnnualLeavePolicy"
              @click="fn_openAnnualLeavePolicyDialog()"
              type="warning"
              round
              class="btn-radius-10 btn-default header-policy-btn"
            >
              Thiết lập cấu hình nghỉ phép
            </el-button>
            <el-button
              @click="fn_tableShowFormSearch()"
              type="info"
              round
              class="btn-radius-10 btn-default header-search-toggle"
            >
              Ẩn/hiện tìm kiếm
            </el-button>
          </div>
        </div>
        <div class="main-body mt-1 scroll-css">
          <div class="main-body-search mb-2">
            <b-collapse
              v-bind:visible="mData.tableRules.showFormSearch"
              id="myFormSearch"
            >
              <b-card>
                <el-form
                  ref="searchForm"
                  label-position="left"
                  label-width="160px"
                  @submit.native.prevent
                  :model="mData.tableRules.dataSearch.value"
                  :rules="mData.tableRules.dataSearch.valid"
                  class="search-form"
                >
                  <b-row class="search-grid">
                    <b-col xl="6" md="12" v-if="false">
                      <el-form-item label="Năm">
                        <el-date-picker
                          class="year"
                          v-model="mData.dataForm.curentYear"
                          type="year"
                          :default-value="new Date()"
                          :clearable="false"
                          :editable="false"
                          format="yyyy"
                          value-format="yyyy"
                          @change="fn_searchYear"
                        >
                        </el-date-picker>
                      </el-form-item>
                    </b-col>
                    <b-col xl="4" md="12">
                      <el-form-item label="Công ty">
                        <el-select
                          v-model="mData.tableRules.dataSearch.value['company_id']"
                          @change="fn_handleCompanySearchChange"
                          placeholder="Tất cả"
                          clearable
                          filterable
                        >
                          <el-option
                            label="Tất cả"
                            value=""
                          ></el-option>
                          <el-option
                            v-for="item in mData.dataDefault.listCompany"
                            :key="item.id"
                            :label="item.name.name_vi || item.name.abbreviation_name || item.name"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col xl="4" md="12">
                      <el-form-item label="Phòng ban">
                        <el-select
                          v-model="mData.tableRules.dataSearch.value['job_info.department_id']"
                          placeholder="Tất cả"
                          clearable
                          filterable
                        >
                          <el-option
                            label="Tất cả"
                            value=""
                          ></el-option>
                          <el-option
                            v-for="item in mData.dataDefault.listDepartment"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col xl="4" md="12">
                      <el-form-item label="Chức vụ">
                        <el-select
                          v-model="mData.tableRules.dataSearch.value['job_info.position_id']"
                          placeholder="Tất cả"
                          clearable
                          filterable
                        >
                          <el-option
                            label="Tất cả"
                            value=""
                          ></el-option>
                          <el-option
                            v-for="item in mData.dataDefault.listPosition"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                  </b-row>
                  <div class="search-actions mt-1">
                    <div class="condition-search">
                      <label class="condition-search__label">Điều kiện:</label>
                      <el-input
                        v-model="mData.tableRules.dataSearch.value.condition"
                        placeholder="Nhập Mã nhân viên, Họ và tên"
                        clearable
                      ></el-input>
                    </div>
                    <el-button
                      round
                      native-type="submit"
                      @click="fn_tableSearch()"
                      class="btn-default"
                    >
                      Tìm kiếm
                    </el-button>
                    
                  </div>
                </el-form>
              </b-card>
            </b-collapse>
          </div>
          <el-table
            :data="mData.tableRules.data"
            style="width: 100%"
            :max-height="mData.tableMaxHeight"
            border
          >
            <el-table-column
              label="STT"
              width="45"
              align="center"
            >
              <template slot-scope="scope">
                {{ mData.tableRules.offset + scope.$index + 1}}
              </template>
            </el-table-column>
            <el-table-column
              prop="year"
              label="Năm"
              width="50"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="employee_no"
              label="Mã nhân viên"
              min-width="100"
            >
            </el-table-column>
            <el-table-column
              prop="administrative_info.name.full_name"
              label="Tên nhân viên"
              min-width="150"
            >
            </el-table-column>
            <el-table-column
              label="Phòng ban"
              min-width="110"
            >
              <template slot-scope="scope">
                {{ scope.row.phong_ban }}
              </template>
            </el-table-column>
            <el-table-column
              label="Chức vụ"
              min-width="110"
            >
              <template slot-scope="scope">
                {{scope.row.chuc_vu}}
              </template>
            </el-table-column>
            <el-table-column
              label="Số ngày nghỉ có phép"
              min-width="145"
              align="center"
            >
              <template slot-scope="scope">
                <el-input-number
                  :disabled="mData.yearSelectSmallerThanCurrentYear"
                  :ref="`allowDayoff_${scope.$index}`"
                  :class="{fake_p: true}"
                  v-model="scope.row.day_off.allow_dayoff_number"
                  :min="0"
                  :max="100"
                  :controls="false"
                  :step-strictly="true"
                  @focus="focusInput(scope.$index, scope)"
                  @blur="blurInput(scope.$index, scope)"
                ></el-input-number>
              </template>
            </el-table-column>
            <el-table-column
              prop="day_off.remain_allow_dayoff_number"
              label="Số ngày phép còn lại"
              min-width="145"
              align="center"
            >
              <template slot-scope="scope">
                <span class="remaining-dayoff-value">
                  {{ scope.row.day_off.remain_allow_dayoff_number || 0 }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              prop="day_off.carry_over_remain_dayoff_number"
              label="Số ngày phép bảo lưu"
              min-width="150"
              align="center"
            >
              <template slot-scope="scope">
                <span class="remaining-dayoff-value">
                  {{ scope.row.day_off.carry_over_remain_dayoff_number || 0 }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              label="Số ngày nghỉ không phép"
              min-width="170"
              align="center"
            >
              <template slot-scope="scope">
                <el-input-number
                  :disabled="mData.yearSelectSmallerThanCurrentYear"
                  :ref="`unallowDayoff_${scope.$index}`"
                  :class="{fake_p: true}"
                  v-model="scope.row.day_off.unallow_dayoff_number"
                  :min="0"
                  :max="100"
                  :controls="false"
                  :step-strictly="true"
                  @focus="focusInput(scope.$index, scope)"
                  @blur="blurInput(scope.$index, scope)"
                ></el-input-number>
              </template>
            </el-table-column>
            <el-table-column
              prop="day_off.remain_unallow_dayoff_number"
              label="Số ngày nghỉ không phép còn lại"
              min-width="190"
              align="center"
            >
              <template slot-scope="scope">
                <span class="remaining-dayoff-value">
                  {{ scope.row.day_off.remain_unallow_dayoff_number || 0 }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              label="Thao tác"
              width="75"
              align="center"
              v-if="!mData.yearSelectSmallerThanCurrentYear"
            >
              <template slot-scope="scope">
                <el-button
                  v-if="!mData.yearSelectSmallerThanCurrentYear"
                  size="mini"
                  type="success"
                  plain
                  round
                  v-b-popover.hover.left="'Cập nhật'"
                  @click="fn_handle('save',scope.$index, scope.row.day_off)"
                >
                  <i class="fas fa-check"></i>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <b-row class="mt-2 table-footer-actions">
            <div class="col-md-12 text-right leave-history-action-row">
              <el-button
                round
                type="warning"
                class="btn-radius-10 btn-default leave-history-btn"
                @click="fn_openLeaveDeductionHistoryDialog()"
              >
                Xem lịch sử nghỉ phép
              </el-button>
            </div>
            <div class="col-md-12 text-right pagination-action-row" v-if="mData.tableRules.allowPaging">
              <el-pagination
                @size-change="fn_tableSizeChange"
                @current-change="fn_tableCurentChange"
                @prev-click="fn_tablePrevClick"
                @next-click="fn_tableNextClick"
                :page-sizes="mData.tableRules.lengthMenu"
                :page-size="mData.tableRules.limit"
                :current-page="mData.tableRules.page"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="mData.tableRules.total"
                :pager-count="5"
              ></el-pagination>
            </div>
          </b-row>
        </div>
      </div>
    </div>
    <el-dialog
      title="Lịch sử trừ phép"
      :visible.sync="mData.leaveDeductionHistoryDialog.visible"
      width="1280px"
      custom-class="leave-deduction-history-dialog"
    >
      <div class="leave-history-filter-bar">
        <div class="leave-history-date-group">
          <el-date-picker
            v-model="mData.leaveDeductionHistoryDialog.filter.fromDate"
            type="date"
            placeholder="Từ ngày"
            format="dd/MM/yyyy"
            value-format="yyyy-MM-dd"
            class="leave-history-date-filter"
          />
          <el-date-picker
            v-model="mData.leaveDeductionHistoryDialog.filter.toDate"
            type="date"
            placeholder="Đến ngày"
            format="dd/MM/yyyy"
            value-format="yyyy-MM-dd"
            class="leave-history-date-filter"
          />
        </div>
        <el-input
          v-model="mData.leaveDeductionHistoryDialog.filter.keyword"
          clearable
          placeholder="Tìm kiếm"
          class="leave-history-keyword-filter"
        />
      </div>
      <el-table
        :data="fn_getFilteredLeaveDeductionHistory()"
        v-loading="mData.leaveDeductionHistoryDialog.loading"
        border
        max-height="520"
        empty-text="Chưa có lịch sử trừ phép"
      >
        <el-table-column label="STT" width="50" align="center">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="approval_at_text" label="Thời gian" min-width="120" align="center" />
        <el-table-column prop="employee_no" label="Mã nhân viên" min-width="100" />
        <el-table-column prop="employee_name" label="Tên nhân viên" min-width="170" />
        <el-table-column prop="year" label="Năm phép" width="95" align="center" />
        <el-table-column prop="carry_over_amount_text" label="Số phép bảo lưu" min-width="125" align="center" />
        <el-table-column prop="current_year_amount_text" label="Số phép năm" min-width="115" align="center" />
        <el-table-column prop="unallow_amount_text" label="Không phép" min-width="105" align="center" />
        <el-table-column prop="content" label="Nội dung" min-width="330" />
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button round @click="mData.leaveDeductionHistoryDialog.visible = false">Đóng</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="Thiết lập cấu hình nghỉ phép"
      :visible.sync="mData.policyDialog.visible"
      width="600px"
      :close-on-click-modal="false"
      custom-class="annual-leave-policy-dialog"
    >
      <div class="policy-form">
        <div class="policy-form__hint" v-if="!mData.policyDialog.form.enabled">
          Công ty chưa cấu hình nên số phép vẫn được quản lý thủ công như hiện tại.
        </div>
        <el-form label-position="left" label-width="235px" class="policy-el-form">
          <el-form-item label="Áp dụng từ ngày">
            <el-date-picker
              v-model="mData.policyDialog.form.effective_from"
              type="date"
              format="dd/MM/yyyy"
              value-format="yyyy-MM-ddTHH:mm:ss"
              :clearable="false"
              :disabled="mData.policyDialog.form.enabled"
              class="policy-field"
            />
          </el-form-item>
          <el-form-item label="Số phép cộng mỗi tháng">
            <el-input-number
              v-model="mData.policyDialog.form.monthly_accrual"
              :min="0.5"
              :step="0.5"
              :disabled="mData.policyDialog.form.enabled"
              class="policy-field"
            />
          </el-form-item>
          <el-form-item label="Ngày tính phép tháng đầu">
            <el-input-number
              v-model="mData.policyDialog.form.first_month_cutoff_day"
              :min="1"
              :max="31"
              :disabled="mData.policyDialog.form.enabled"
              class="policy-field"
            />
          </el-form-item>
          <el-form-item label="Loại hợp đồng áp dụng">
            <el-select
              v-model="mData.policyDialog.form.contract_type_ids"
              multiple
              filterable
              collapse-tags
              :disabled="mData.policyDialog.form.enabled"
              class="policy-field"
            >
              <el-option
                v-for="item in mData.dataDefault.listContractType"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="Cộng phép theo thâm niên">
            <el-switch
              v-model="mData.policyDialog.form.seniority_accrual_enabled"
              :disabled="mData.policyDialog.form.enabled"
            />
          </el-form-item>
          <template v-if="mData.policyDialog.form.seniority_accrual_enabled">
            <el-form-item label="Số năm thâm niên">
              <el-input-number
                v-model="mData.policyDialog.form.seniority_years"
                :min="1"
                :step="1"
                :precision="0"
                :disabled="mData.policyDialog.form.enabled"
                class="policy-field"
              />
            </el-form-item>
            <el-form-item label="Số phép cộng">
              <el-input-number
                v-model="mData.policyDialog.form.seniority_bonus_days"
                :min="1"
                :step="1"
                :precision="0"
                :disabled="mData.policyDialog.form.enabled"
                class="policy-field"
              />
            </el-form-item>
          </template>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button round @click="mData.policyDialog.visible = false">Đóng</el-button>
        <el-button
          v-if="!mData.policyDialog.form.enabled"
          type="warning"
          round
          @click="fn_activateAnnualLeavePolicy()"
        >
          Áp dụng
        </el-button>
        <el-button
          v-else
          type="danger"
          round
          @click="fn_endAnnualLeavePolicy()"
        >
          Kết thúc
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import MethodService from "../../../service/MethodService";
import EmployeeDayOffConfigModel from "./EmployeeDayOffConfigModel";
import EmployeeDayOffApi from '../../../moduleApi/EmployeeDayOffApi';
import EmployeeApi from '../../../moduleApi/EmployeeApi';
import CompanyApi from '../../../moduleApi/CompanyApi';
import DepartmentApi from '../../../moduleApi/DepartmentApi';
import PositionApi from '../../../moduleApi/PositionApi';
import BranchApi from '../../../moduleApi/BranchApi';
import ContractTypeApi from '../../../moduleApi/ContractTypeApi';
import EmployeeRequestApi from '../../../moduleApi/EmployeeRequestApi';

export default {
  components: {},
  data() {
    return {
      aRole: MethodService.checkRole,
      aElement: MethodService.element,
      mData: {
        id: null,
        yearSelectSmallerThanCurrentYear: false,
        oldRowData: {
          allow_dayoff_number: undefined,
          unallow_dayoff_number: undefined
        },
        oldRowDataBlur: {
          allow_dayoff_number: undefined,
          unallow_dayoff_number: undefined
        },
        previousRowClick: "null",
        previousRowBlur: "null",
        typeCellPreviousClick: "null",
        viewMode: "create",
        moduleName: "EmployeeDayOffConfig", //requied
        tableRules: MethodService.copyObject(EmployeeDayOffConfigModel.tableRules),
        dataDefault: {
          listEmployeeDayOff: [],
          listEmployee: [],
          listCompany: [],
          listContractTypeAll: [],
          listContractType: [],
          listPositionAll: [],
          listPosition: [],
          listDepartmentAll: [],
          listDepartment: [],
          listBranch: []
        },
        dataForm: {
          curentYear: new Date(),
        },
        canManageAnnualLeavePolicy: MethodService.checkRole("AdminSystem") || MethodService.checkHaveFeature("FT406"),
        policyDialog: {
          visible: false,
          form: {
            enabled: false,
            effective_from: "",
            monthly_accrual: 1,
            first_month_cutoff_day: 10,
            maximum_days_per_year: 12,
            contract_type_ids: [],
            seniority_accrual_enabled: false,
            seniority_years: 1,
            seniority_bonus_days: 1,
          }
        },
        leaveDeductionHistoryDialog: {
          visible: false,
          loading: false,
          data: [],
          filter: {
            fromDate: "",
            toDate: "",
            keyword: ""
          }
        },
        currentUser: {},
        companyInfo: {},
        tableMaxHeight: 0
      },
    };
  },

  methods: {
    fn_normalizeCompanyOptions(source) {
      if (Array.isArray(source)) {
        return source;
      }
      if (source && Array.isArray(source.companies)) {
        return source.companies;
      }
      return [];
    },
    fn_getCompanyTreeScope(companies = [], rootCompanyId) {
      if (!rootCompanyId || !Array.isArray(companies) || companies.length === 0) {
        return [];
      }
      const companyMap = new Map();
      companies.forEach(item => {
        if (item && item.id) {
          companyMap.set(item.id, item);
        }
      });
      const scope = [];
      const visited = new Set();
      const stack = [rootCompanyId];
      while (stack.length > 0) {
        const currentId = stack.pop();
        if (!currentId || visited.has(currentId)) {
          continue;
        }
        visited.add(currentId);
        const currentCompany = companyMap.get(currentId);
        if (currentCompany) {
          scope.push(currentCompany);
        }
        companies.forEach(item => {
          if (item && item.parent_company_id === currentId && !visited.has(item.id)) {
            stack.push(item.id);
          }
        });
      }
      return scope;
    },
    fn_mergeCompanyScope(primaryCompanies = [], fallbackCompanies = []) {
      const companyMap = new Map();
      [
        ...this.fn_normalizeCompanyOptions(primaryCompanies),
        ...this.fn_normalizeCompanyOptions(fallbackCompanies),
      ].forEach(item => {
        if (item && item.id && !companyMap.has(item.id)) {
          companyMap.set(item.id, item);
        }
      });
      return Array.from(companyMap.values());
    },
    fn_getSelectedCompanyIds() {
      const companyValue = this.mData.tableRules.dataSearch.value.company_id;
      if (Array.isArray(companyValue)) {
        const selectedIds = companyValue.filter(Boolean);
        return selectedIds.length > 0 ? selectedIds : this.fn_getDefaultCompanyIds();
      }
      if (companyValue) {
        return [companyValue];
      }
      return this.fn_getDefaultCompanyIds();
    },
    fn_getDefaultCompanyIds() {
      return this.mData.companyInfo && this.mData.companyInfo.id
        ? [this.mData.companyInfo.id]
        : [];
    },
    fn_getActiveCompanyId() {
      const companyIds = this.fn_getSelectedCompanyIds();
      return companyIds.length > 0 ? companyIds[0] : "";
    },
    fn_hasSelectedAllCompany() {
      return this.fn_getSelectedCompanyIds().length === 0;
    },
    async fn_applyDepartmentOptionsByCompany() {
      const companyIds = this.fn_getSelectedCompanyIds();
      if (this.fn_hasSelectedAllCompany()) {
        this.mData.dataDefault.listDepartment =
          this.mData.dataDefault.listDepartmentAll.slice();
        return;
      }
      const filters = companyIds.length === 1
        ? `company_id=${companyIds[0]}`
        : `company_id:in:${companyIds.join(",")}`;
      const departmentApiRes = await DepartmentApi.list({
        limit: 10000,
        filters,
      });
      const departmentOptions = departmentApiRes.result || [];
      this.mData.dataDefault.listDepartment = departmentOptions;
      const selectedDepartmentId =
        this.mData.tableRules.dataSearch.value["job_info.department_id"];
      if (
        selectedDepartmentId &&
        !departmentOptions.some((item) => item.id === selectedDepartmentId)
      ) {
        this.mData.tableRules.dataSearch.value["job_info.department_id"] = "";
      }
    },
    fn_applyPositionOptionsByCompany() {
      const companyIds = this.fn_getSelectedCompanyIds();
      let positionOptions = this.mData.dataDefault.listPositionAll || [];
      if (!this.fn_hasSelectedAllCompany()) {
        positionOptions = positionOptions.filter((item) => {
          if (!item) return false;
          return (
            companyIds.includes(item.company_id) ||
            item.company_id === "system" ||
            item.company_id === null ||
            item.company_id === undefined ||
            item.company_id === ""
          );
        });
      }
      this.mData.dataDefault.listPosition = positionOptions;
      const selectedPositionId =
        this.mData.tableRules.dataSearch.value["job_info.position_id"];
      if (
        selectedPositionId &&
        !positionOptions.some((item) => item.id === selectedPositionId)
      ) {
        this.mData.tableRules.dataSearch.value["job_info.position_id"] = "";
      }
    },
    async fn_handleCompanySearchChange() {
      if (this.fn_hasSelectedAllCompany()) {
        this.mData.tableRules.dataSearch.value.company_id = "";
      }
      await this.fn_applyDepartmentOptionsByCompany();
      this.fn_applyPositionOptionsByCompany();
      this.fn_applyContractTypeOptionsByCompany();
    },
    fn_applyContractTypeOptionsByCompany() {
      this.mData.dataDefault.listContractType = this.mData.dataDefault.listContractTypeAll || [];
      this.mData.policyDialog.form.contract_type_ids =
        (this.mData.policyDialog.form.contract_type_ids || []).filter((id) =>
          this.mData.dataDefault.listContractType.some((item) => item.id === id)
        );
    },
    fn_getPolicyCompanyId() {
      const companyIds = this.fn_getSelectedCompanyIds();
      return companyIds.length > 0 ? companyIds[0] : (this.mData.companyInfo && this.mData.companyInfo.id);
    },
    fn_getAnnualLeaveMaximumDaysPerYear() {
      const monthlyAccrual = Number(this.mData.policyDialog.form.monthly_accrual) || 0;
      return Math.round(monthlyAccrual * 12 * 100) / 100;
    },
    fn_buildAnnualLeavePolicyPayload() {
      return {
        company_id: this.fn_getPolicyCompanyId(),
        effective_from: this.mData.policyDialog.form.effective_from,
        monthly_accrual: this.mData.policyDialog.form.monthly_accrual,
        first_month_cutoff_day: this.mData.policyDialog.form.first_month_cutoff_day,
        maximum_days_per_year: this.fn_getAnnualLeaveMaximumDaysPerYear(),
        contract_type_ids: this.mData.policyDialog.form.contract_type_ids || [],
        seniority_accrual_enabled: !!this.mData.policyDialog.form.seniority_accrual_enabled,
        seniority_years: this.mData.policyDialog.form.seniority_accrual_enabled
          ? this.mData.policyDialog.form.seniority_years
          : 0,
        seniority_bonus_days: this.mData.policyDialog.form.seniority_accrual_enabled
          ? this.mData.policyDialog.form.seniority_bonus_days
          : 0,
        transition_strategy: "RECALCULATE",
      };
    },
    fn_applyAnnualLeavePolicyResult(result = {}) {
      const options = result.options || {};
      this.mData.policyDialog.form = {
        enabled: !!options.enabled,
        effective_from: options.effective_from || "",
        monthly_accrual: options.monthly_accrual || 1,
        first_month_cutoff_day: options.first_month_cutoff_day || 10,
        maximum_days_per_year: options.maximum_days_per_year || 12,
        contract_type_ids: options.contract_type_ids || [],
        seniority_accrual_enabled: !!options.seniority_accrual_enabled,
        seniority_years: options.seniority_years || 1,
        seniority_bonus_days: options.seniority_bonus_days || 1,
      };
      this.mData.canManageAnnualLeavePolicy =
        !!result.can_manage || MethodService.checkRole("AdminSystem") || MethodService.checkHaveFeature("FT406");
      this.fn_applyContractTypeOptionsByCompany();
    },
    async fn_openAnnualLeavePolicyDialog() {
      const companyId = this.fn_getPolicyCompanyId();
      if (!companyId) {
        window.toastr.warning("Không xác định được công ty để cấu hình.");
        return;
      }
      this.mData.policyDialog.visible = true;
      try {
        const response = await CompanyApi.GetAnnualLeavePolicy({ company_id: companyId });
        this.fn_applyAnnualLeavePolicyResult(response.result || {});
      } catch (error) {
        console.error("[AnnualLeavePolicy] Không thể tải cấu hình", error);
        window.toastr.error("Không thể tải cấu hình nghỉ phép. Vui lòng kiểm tra backend và thử lại.");
      }
    },
    async fn_saveAnnualLeavePolicyDraft() {
      const response = await CompanyApi.SaveAnnualLeavePolicyDraft(this.fn_buildAnnualLeavePolicyPayload());
      this.fn_applyAnnualLeavePolicyResult(response.result || {});
    },
    async fn_activateAnnualLeavePolicy() {
      const response = await CompanyApi.ActivateAnnualLeavePolicy(this.fn_buildAnnualLeavePolicyPayload());
      this.fn_applyAnnualLeavePolicyResult(response.result || {});
      this.mData.policyDialog.visible = false;
      await this.fn_initTable();
    },
    async fn_endAnnualLeavePolicy() {
      const response = await CompanyApi.EndAnnualLeavePolicy({ company_id: this.fn_getPolicyCompanyId() });
      this.fn_applyAnnualLeavePolicyResult(response.result || {});
      this.mData.policyDialog.visible = false;
      await this.fn_initTable();
    },
    fn_updateTableHeight() {
      const collapsedOffset = 315;
      const expandedOffset = 440;
      const minTableHeight = 320;
      const offset = this.mData.tableRules.showFormSearch
        ? expandedOffset
        : collapsedOffset;

      this.mData.tableMaxHeight = Math.max(
        window.innerHeight - offset,
        minTableHeight
      );
    },
    fn_getCurrentYearValue() {
      return typeof this.mData.dataForm.curentYear == "object"
        ? this.mData.dataForm.curentYear.getFullYear()
        : this.mData.dataForm.curentYear;
    },
    fn_getDayOffSearchFilter() {
      const companyIds = this.fn_getSelectedCompanyIds();
      return MethodService.filterTable(
        JSON.stringify({
          value: {
            year: this.mData.tableRules.dataSearch.value.year,
            company_id: companyIds,
          },
          operator: {
            year: this.mData.tableRules.dataSearch.operator.year,
            company_id: this.mData.tableRules.dataSearch.operator.company_id,
          },
        })
      );
    },
    fn_getEmployeeSearchFilter() {
      const companyIds = this.fn_getSelectedCompanyIds();
      return MethodService.filterTable(
        JSON.stringify({
          value: {
            company_id: companyIds,
            employee_no: this.mData.tableRules.dataSearch.value.employee_no,
            "administrative_info.name.full_name":
              this.mData.tableRules.dataSearch.value[
                "administrative_info.name.full_name"
              ],
          },
          operator: {
            company_id: this.mData.tableRules.dataSearch.operator.company_id,
            employee_no: this.mData.tableRules.dataSearch.operator.employee_no,
            "administrative_info.name.full_name":
              this.mData.tableRules.dataSearch.operator[
                "administrative_info.name.full_name"
              ],
          },
        })
      );
    },
    fn_getEmployeeConditionScore(item, condition) {
      const rawKeyword = `${condition || ""}`.trim().toLowerCase();
      const aliasKeyword = MethodService.changeAlias(condition || "");
      if (!rawKeyword && !aliasKeyword) return 1;
      const hasAccentedKeyword = rawKeyword !== aliasKeyword;
      const normalizeValue = (value) => ({
        raw: `${value || ""}`.toLowerCase(),
        alias: MethodService.changeAlias(`${value || ""}`),
      });
      const scoreByMatch = (source, exact, startsWith, includes, rawBonus = 20) => {
        if (!source.raw) return 0;
        if (source.raw === rawKeyword) return exact + rawBonus;
        if (source.raw.startsWith(rawKeyword)) return startsWith + rawBonus;
        if (source.raw.includes(rawKeyword)) return includes + rawBonus;
        if (hasAccentedKeyword) return 0;
        if (source.alias === aliasKeyword) return exact;
        if (source.alias.startsWith(aliasKeyword)) return startsWith;
        if (source.alias.includes(aliasKeyword)) return includes;
        return 0;
      };

      const fullName = item.administrative_info && item.administrative_info.name
        ? item.administrative_info.name.full_name
        : "";
      const firstName = item.administrative_info && item.administrative_info.name
        ? item.administrative_info.name.first_name
        : "";
      const fullNameSource = normalizeValue(fullName);
      const firstNameSource = normalizeValue(firstName);
      const fullNameWords = fullNameSource.raw.split(" ").filter(Boolean);
      const aliasFullNameWords = fullNameSource.alias.split(" ").filter(Boolean);
      const fullNameScore = Math.max(
        scoreByMatch(firstNameSource, 280, 260, 0),
        scoreByMatch(fullNameSource, 240, 180, 160),
        fullNameWords.some((word) => word === rawKeyword) ? 240 : 0,
        fullNameWords.some((word) => word.startsWith(rawKeyword)) ? 220 : 0,
        fullNameSource.raw.includes(` ${rawKeyword}`) ? 180 : 0,
        hasAccentedKeyword ? 0 : (
          (aliasFullNameWords.some((word) => word === aliasKeyword) ? 200 : 0) ||
          (aliasFullNameWords.some((word) => word.startsWith(aliasKeyword)) ? 180 : 0) ||
          (fullNameSource.alias.includes(` ${aliasKeyword}`) ? 140 : 0)
        )
      );

      return Math.max(
        fullNameScore,
        scoreByMatch(normalizeValue(item.employee_no), 70, 60, 50)
      );
    },
    fn_getEmployeeConditionStatusPriority(status) {
      const normalizedStatus = MethodService.changeAlias(`${status || ""}`).toLowerCase();

      if (status === "DANG_LAM_VIEC" || normalizedStatus === "dang lam viec") {
        return 0;
      }
      if (status === "DA_NGHI" || normalizedStatus === "da nghi viec" || normalizedStatus === "da nghi") {
        return 1;
      }
      if (status === "NGHI_SINH" || normalizedStatus === "nghi sinh") {
        return 2;
      }

      return 3;
    },
    fn_sortEmployeeConditionResult(a, b) {
      return (
        this.fn_getEmployeeConditionStatusPriority(a.item && a.item.status) -
        this.fn_getEmployeeConditionStatusPriority(b.item && b.item.status) ||
        b.score - a.score ||
        a.index - b.index
      );
    },
    fn_applyLocalTableFilter(resData) {
      const departmentId =
        this.mData.tableRules.dataSearch.value["job_info.department_id"];
      const positionId =
        this.mData.tableRules.dataSearch.value["job_info.position_id"];
      const condition = (
        this.mData.tableRules.dataSearch.value.condition || ""
      ).trim();
      const allowDayoffNumber =
        this.mData.tableRules.dataSearch.value.allow_dayoff_number;
      const unallowDayoffNumber =
        this.mData.tableRules.dataSearch.value.unallow_dayoff_number;
      const filteredData = (resData || []).filter((item) => {
        if (
          departmentId &&
          item.current_department_id !== departmentId
        ) {
          return false;
        }
        if (
          positionId &&
          item.current_position_id !== positionId
        ) {
          return false;
        }
        if (
          allowDayoffNumber !== "" &&
          allowDayoffNumber !== null &&
          allowDayoffNumber !== undefined &&
          Number(item.day_off && item.day_off.allow_dayoff_number) !==
            Number(allowDayoffNumber)
        ) {
          return false;
        }
        if (
          unallowDayoffNumber !== "" &&
          unallowDayoffNumber !== null &&
          unallowDayoffNumber !== undefined &&
          Number(item.day_off && item.day_off.unallow_dayoff_number) !==
            Number(unallowDayoffNumber)
        ) {
          return false;
        }
        return true;
      });
      if (!condition) {
        return filteredData;
      }
      return filteredData
        .map((item, index) => ({
          item,
          index,
          score: this.fn_getEmployeeConditionScore(item, condition),
        }))
        .filter((item) => item.score > 0)
        .sort((a, b) => this.fn_sortEmployeeConditionResult(a, b))
        .map((item) => item.item);
    },
    fn_chunkArray(items, size) {
      const result = [];
      for (let index = 0; index < items.length; index += size) {
        result.push(items.slice(index, index + size));
      }
      return result;
    },
    fn_getEmployeeDisplayMap(employees = []) {
      const employeeMap = new Map();
      (employees || []).forEach((item) => {
        if (!item || !item.id) {
          return;
        }
        employeeMap.set(item.id, {
          employee_no: item.employee_no || "",
          employee_name:
            item.administrative_info &&
            item.administrative_info.name &&
            item.administrative_info.name.full_name
              ? item.administrative_info.name.full_name
              : ""
        });
      });
      return employeeMap;
    },
    fn_getLeaveHistoryYearRange() {
      const year = parseInt(this.fn_getCurrentYearValue(), 10) || new Date().getFullYear();
      return {
        year,
        from: `${year}-01-01T00:00:00`,
        to: `${year}-12-31T23:59:59`
      };
    },
    fn_formatLeaveHistoryNumber(value) {
      const numberValue = Number(value || 0);
      return Number.isInteger(numberValue) ? numberValue : Number(numberValue.toFixed(2));
    },
    fn_formatLeaveHistorySignedNumber(value, signType) {
      const numberValue = this.fn_formatLeaveHistoryNumber(value);
      if (numberValue === 0) {
        return "0";
      }
      return `${signType === "plus" ? "+" : "-"}${numberValue}`;
    },
    fn_getLeaveHistoryCarryOverSign(item = {}) {
      return item.event_type === "CARRY_OVER_CREATED" ? "plus" : "minus";
    },
    fn_buildLeaveHistoryContent(item = {}) {
      if (item.content) {
        return item.content;
      }
      const carryOverAmount = this.fn_formatLeaveHistoryNumber(item.carry_over_amount);
      const currentYearAmount = this.fn_formatLeaveHistoryNumber(item.current_year_amount);
      const unallowAmount = this.fn_formatLeaveHistoryNumber(item.unallow_amount);
      const parts = [];
      if (carryOverAmount > 0) {
        parts.push(`sử dụng ${carryOverAmount} ngày phép bảo lưu`);
      }
      if (currentYearAmount > 0) {
        parts.push(`sử dụng ${currentYearAmount} ngày phép năm`);
      }
      if (unallowAmount > 0) {
        parts.push(`sử dụng ${unallowAmount} ngày nghỉ không phép`);
      }
      return parts.length > 0 ? `Nhân viên ${parts.join(", ")} để nghỉ.` : "";
    },
    fn_getFilteredLeaveDeductionHistory() {
      const dialog = this.mData.leaveDeductionHistoryDialog;
      const fromDateValue = dialog.filter.fromDate;
      const toDateValue = dialog.filter.toDate;
      const keyword = (dialog.filter.keyword || "").trim().toLowerCase();
      return (dialog.data || []).filter((item) => {
        if (fromDateValue || toDateValue) {
          if (!item.approval_at) {
            return false;
          }
          const itemDate = new Date(item.approval_at);
          const fromDate = fromDateValue ? new Date(`${fromDateValue}T00:00:00`) : null;
          const toDate = toDateValue ? new Date(`${toDateValue}T23:59:59`) : null;
          if (fromDate && itemDate < fromDate) {
            return false;
          }
          if (toDate && itemDate > toDate) {
            return false;
          }
        }
        if (!keyword) {
          return true;
        }
        const searchableText = [
          item.approval_at_text,
          item.employee_no,
          item.employee_name,
          item.content,
          item.year,
          item.carry_over_amount,
          item.current_year_amount,
          item.unallow_amount,
          item.carry_over_amount_text,
          item.current_year_amount_text,
          item.unallow_amount_text
        ].join(" ").toLowerCase();
        return searchableText.includes(keyword);
      });
    },
    async fn_openLeaveDeductionHistoryDialog() {
      this.mData.leaveDeductionHistoryDialog.visible = true;
      await this.fn_loadLeaveDeductionHistory();
    },
    async fn_loadLeaveDeductionHistory() {
      this.mData.leaveDeductionHistoryDialog.loading = true;
      try {
        const range = this.fn_getLeaveHistoryYearRange();
        const historyRes = await EmployeeRequestApi.GetAnnualLeaveDeductionHistory({
          company_id: this.mData.tableRules.dataSearch.value.company_id || this.mData.companyInfo.id,
          year: range.year
        });
        const historyRows = historyRes.result || [];
        this.mData.leaveDeductionHistoryDialog.data = historyRows.map((item) => {
          const carryOverAmount = this.fn_formatLeaveHistoryNumber(item.carry_over_amount);
          const currentYearAmount = this.fn_formatLeaveHistoryNumber(item.current_year_amount);
          const unallowAmount = this.fn_formatLeaveHistoryNumber(item.unallow_amount);
          return {
            request_id: item.request_id || "",
            event_type: item.event_type || "",
            approval_at: item.approval_at || "",
            approval_at_text: item.approval_at
              ? MethodService.formatDate(item.approval_at, "datetime")
              : "",
            employee_no: item.employee_no || item.employee_id || "",
            employee_name: item.employee_name || "",
            content: this.fn_buildLeaveHistoryContent(item),
            year: item.year,
            carry_over_amount: carryOverAmount,
            current_year_amount: currentYearAmount,
            unallow_amount: unallowAmount,
            carry_over_amount_text: this.fn_formatLeaveHistorySignedNumber(
              carryOverAmount,
              this.fn_getLeaveHistoryCarryOverSign(item)
            ),
            current_year_amount_text: this.fn_formatLeaveHistorySignedNumber(currentYearAmount, "minus"),
            unallow_amount_text: this.fn_formatLeaveHistorySignedNumber(unallowAmount, "minus")
          };
        });
      } catch (error) {
        console.log(error);
        this.mData.leaveDeductionHistoryDialog.data = [];
        window.toastr.error("Không tải được lịch sử trừ phép!");
      } finally {
        this.mData.leaveDeductionHistoryDialog.loading = false;
      }
    },
    async fn_initDataDefault(){
      this.mData.currentUser = MethodService.getCurrentUser();
      this.mData.companyInfo = MethodService.getCompanyInfo();
      const companyFilterApiReq = await CompanyApi.GetCompanyFilterOptions({}, true);
      const companyApiReq = await CompanyApi.list({ limit: 1000000 }, true);
      const departmentApiReq =  await DepartmentApi.list({limit: 10000});
      const positionApiReq = await PositionApi.list({limit:10000});
      const branchApiReq = await BranchApi.list({limit: 100});
      const contractTypeApiReq = await ContractTypeApi.list({ limit: 1000000, filters: "disabled!=true" }, true);

      const companyFilterApiRes = await companyFilterApiReq;
      const companyApiRes = await companyApiReq;
      const departmentApiRes = await departmentApiReq;
      const positionApiRes = await positionApiReq;
      const branchApiRes = await branchApiReq;
      const contractTypeApiRes = await contractTypeApiReq;

      const companyFilterOptions = this.fn_normalizeCompanyOptions(companyFilterApiRes.result);
      const allCompanies = this.fn_normalizeCompanyOptions(companyApiRes.result);
      const scopedCompaniesFromTree = this.fn_getCompanyTreeScope(
        allCompanies,
        this.mData.companyInfo && this.mData.companyInfo.id
          ? this.mData.companyInfo.id
          : undefined
      );

      this.mData.dataDefault.listCompany = this.fn_mergeCompanyScope(
        companyFilterOptions,
        scopedCompaniesFromTree.length > 0 ? scopedCompaniesFromTree : allCompanies
      );
      this.mData.dataDefault.listPositionAll = positionApiRes.result || [];
      this.mData.dataDefault.listPosition =
        this.mData.dataDefault.listPositionAll.slice();
      this.mData.dataDefault.listDepartmentAll = departmentApiRes.result || [];
      this.mData.dataDefault.listDepartment =
        this.mData.dataDefault.listDepartmentAll.slice();
      this.mData.dataDefault.listBranch = branchApiRes.result;
      this.mData.dataDefault.listContractTypeAll = contractTypeApiRes.result || [];
      if (!this.mData.tableRules.dataSearch.value.company_id) {
        this.mData.tableRules.dataSearch.value.company_id = this.fn_getActiveCompanyId();
      }
      await this.fn_applyDepartmentOptionsByCompany();
      this.fn_applyPositionOptionsByCompany();
      this.fn_applyContractTypeOptionsByCompany();
    },
    async fn_initTable() {
      if (!this.mData.tableRules.dataSearch.value.year) {
        this.mData.tableRules.dataSearch.value.year =
          this.fn_getCurrentYearValue() || new Date().getFullYear();
      }
      this.mData.tableRules.filters = this.fn_getDayOffSearchFilter();
      let dataFilter = {
        filters: this.mData.tableRules.filters ,
        limit: 3000
      };
      let dataFilterEmployee = {
        filters: "status!=DA_NGHI" ,
      };
      let employeeSearchFilter = this.fn_getEmployeeSearchFilter();
      const hasLocalMergedFilter =
        !!(this.mData.tableRules.dataSearch.value.condition || "").trim() ||
        !!this.mData.tableRules.dataSearch.value["job_info.department_id"] ||
        !!this.mData.tableRules.dataSearch.value["job_info.position_id"] ||
        (
          this.mData.tableRules.dataSearch.value.allow_dayoff_number !== "" &&
          this.mData.tableRules.dataSearch.value.allow_dayoff_number !== null &&
          this.mData.tableRules.dataSearch.value.allow_dayoff_number !== undefined
        ) ||
        (
          this.mData.tableRules.dataSearch.value.unallow_dayoff_number !== "" &&
          this.mData.tableRules.dataSearch.value.unallow_dayoff_number !== null &&
          this.mData.tableRules.dataSearch.value.unallow_dayoff_number !== undefined
        );
      if (employeeSearchFilter) {
        dataFilterEmployee.filters += `&${employeeSearchFilter}`;
      }
      if (hasLocalMergedFilter) {
        dataFilterEmployee.limit = 3000;
        dataFilterEmployee.offset = 0;
      } else if (this.mData.tableRules.allowPaging) {
        dataFilterEmployee.limit = this.mData.tableRules.limit;
        dataFilterEmployee.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilterEmployee.sort = this.mData.tableRules.sort;
      }
      const employeeApiReq = await EmployeeApi.list(dataFilterEmployee);
      if (this.mData.tableRules.showUrl) {
        this.$router.replace({
          name: "Admin-EmployeeDayOffConfig-List",
          query: {
            year: this.mData.tableRules.dataSearch.value.year,
            company_id: this.fn_getActiveCompanyId() || undefined,
            employee_no: this.mData.tableRules.dataSearch.value.employee_no || undefined,
            full_name:
              this.mData.tableRules.dataSearch.value[
                "administrative_info.name.full_name"
              ] || undefined,
            department_id:
              this.mData.tableRules.dataSearch.value["job_info.department_id"] ||
              undefined,
            position_id:
              this.mData.tableRules.dataSearch.value["job_info.position_id"] ||
              undefined,
            condition:
              this.mData.tableRules.dataSearch.value.condition || undefined,
            allow_dayoff_number:
              this.mData.tableRules.dataSearch.value.allow_dayoff_number !== "" &&
              this.mData.tableRules.dataSearch.value.allow_dayoff_number !== null &&
              this.mData.tableRules.dataSearch.value.allow_dayoff_number !== undefined
                ? this.mData.tableRules.dataSearch.value.allow_dayoff_number
                : undefined,
            unallow_dayoff_number:
              this.mData.tableRules.dataSearch.value.unallow_dayoff_number !== "" &&
              this.mData.tableRules.dataSearch.value.unallow_dayoff_number !== null &&
              this.mData.tableRules.dataSearch.value.unallow_dayoff_number !== undefined
                ? this.mData.tableRules.dataSearch.value.unallow_dayoff_number
                : undefined,
            showFormSearch: this.mData.tableRules.showFormSearch,
          },
        }).catch(err => {});
      }
      const employeeDayOffApiReq = await EmployeeDayOffApi.list(dataFilter,false);


      const employeeApiRes = await employeeApiReq;
      const employeeDayOffApiRes = await employeeDayOffApiReq;

      this.mData.dataDefault.listEmployee = employeeApiRes.result || [];
      this.mData.dataDefault.listEmployeeDayOff = employeeDayOffApiRes.result;

      const resData = await this.fn_changeData(employeeApiRes.result);
      const filteredData = this.fn_applyLocalTableFilter(resData);
      if (hasLocalMergedFilter) {
        this.mData.tableRules.total = filteredData.length;
        this.mData.tableRules.page =
          Math.floor(this.mData.tableRules.offset / this.mData.tableRules.limit) + 1;
        this.mData.tableRules.data = this.mData.tableRules.allowPaging
          ? filteredData.slice(
              this.mData.tableRules.offset,
              this.mData.tableRules.offset + this.mData.tableRules.limit
            )
          : filteredData;
      } else {
        this.mData.tableRules.data = filteredData;
        this.mData.tableRules.total = employeeApiRes.meta.total;
        this.mData.tableRules.page = employeeApiRes.meta.offset / employeeApiRes.meta.limit + 1;
      }
      if (
        this.mData.tableRules.offset >= this.mData.tableRules.total &&
        this.mData.tableRules.offset != 0
      ) {
        this.mData.tableRules.offset = 0;
        this.mData.tableRules.page = 1;
        this.fn_initTable();
      }
    },
    async fn_searchYear(){
      if(parseInt(this.fn_getCurrentYearValue()) < new Date().getFullYear()){
        this.mData.yearSelectSmallerThanCurrentYear = true;
      }else{
        this.mData.yearSelectSmallerThanCurrentYear = false;
      }
      this.mData.tableRules.dataSearch.value.year = this.fn_getCurrentYearValue();
      this.mData.tableRules.filters = this.fn_getDayOffSearchFilter();
      this.mData.tableRules.offset = 0;
      this.mData.tableRules.page = 1;
      this.fn_initTable();
    },
    fn_tableSearch() {
      if (this.mData.tableRules.dataSearch.value.condition) {
        this.mData.tableRules.dataSearch.value.condition =
          this.mData.tableRules.dataSearch.value.condition.trim();
      }
      this.mData.tableRules.dataSearch.value.year = this.fn_getCurrentYearValue();
      this.mData.tableRules.offset = 0;
      this.mData.tableRules.page = 1;
      this.fn_initTable();
    },
    fn_tableResetSearch() {
      this.mData.dataForm.curentYear = new Date().getFullYear().toString();
      this.mData.yearSelectSmallerThanCurrentYear = false;
      this.mData.tableRules.dataSearch.value = {
        year: this.mData.dataForm.curentYear,
        company_id: this.fn_getDefaultCompanyIds()[0] || "",
        employee_no: "",
        "administrative_info.name.full_name": "",
        "job_info.department_id": "",
        "job_info.position_id": "",
        condition: "",
        allow_dayoff_number: "",
        unallow_dayoff_number: "",
      };
      this.mData.tableRules.offset = 0;
      this.mData.tableRules.page = 1;
      this.fn_initTable();
    },
    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch =
        !this.mData.tableRules.showFormSearch;
      this.$nextTick(() => {
        this.fn_updateTableHeight();
      });
      let query = Object.assign({}, this.$route.query);
      query.showFormSearch = this.mData.tableRules.showFormSearch;
      this.$router.push({
        name: "Admin-" + this.mData.moduleName + "-List",
        query: query,
      }).catch(() => {});
    },

    //xử lý dữ liệu đầu ra
    async fn_changeData(resData) {
      resData.forEach(item => {
        item.year = typeof this.mData.dataForm.curentYear == "object" ? this.mData.dataForm.curentYear.getFullYear() : this.mData.dataForm.curentYear;
        item.showButtonUpdate = false;
        item.day_off = {
          year: typeof this.mData.dataForm.curentYear == "object" ? this.mData.dataForm.curentYear.getFullYear() : this.mData.dataForm.curentYear,
          employee_id: item.id,
          company_id: this.fn_getActiveCompanyId() || this.mData.companyInfo.id,
          allow_dayoff_number: 0,
          remain_allow_dayoff_number: 0,
          carry_over_remain_dayoff_number: 0,
          unallow_dayoff_number: 0,
          remain_unallow_dayoff_number: 0,
        };

        item.chuc_vu = "";
        item.phong_ban = "";
        item.chi_nhanh = "";
        let curentTime = new Date().getTime();
        let validJobInfo = item.job_info.filter(e => {
            if(e.end_date){
                return new Date(e.start_date).getTime() <= curentTime && curentTime <= new Date(e.end_date).getTime()
            }else{
                  return new Date(e.start_date).getTime() <= curentTime
            }
        })
        item.current_position_id =
          validJobInfo[0] && validJobInfo[0].position_id
            ? validJobInfo[0].position_id
            : "";
        item.current_department_id =
          validJobInfo[0] && validJobInfo[0].department_id
            ? validJobInfo[0].department_id
            : "";
        let chucVu = this.mData.dataDefault.listPositionAll.find( element =>
            {
                return element.id == item.current_position_id;
            }
        )
        let phongBan = this.mData.dataDefault.listDepartment.find( element =>
            {
                return element.id == item.current_department_id;
            }
        )
        let chiNhanh = this.mData.dataDefault.listBranch.find( element =>
            {
                return element.id == (validJobInfo[0] && validJobInfo[0].branch_id ? validJobInfo[0].branch_id : "" );
            }
        )
        if(chucVu && chucVu.name ){
            item.chuc_vu = chucVu.name;
        }else{
            item.chuc_vu = " ";
        }
        if(phongBan && phongBan.name ){
            item.phong_ban = phongBan.name;
        }else{
            item.phong_ban = " ";
        }
        if(chiNhanh && chiNhanh.name ){
            item.chi_nhanh = chiNhanh.name;
        }else{
            item.chi_nhanh = " ";
        }
        this.mData.dataDefault.listEmployeeDayOff.forEach(element => {
          if(element.employee_id == item.id){
            item.day_off = element;
          }
        })
      });
      // let a = resData.sort(function(a,b) {
      //   var nameA = a.administrative_info.name.first_name.toUpperCase(); // ignore upper and lowercase
      //   var nameB = b.administrative_info.name.first_name.toUpperCase(); // ignore upper and lowercase
      //   if (nameA < nameB) {
      //     return -1;
      //   }
      //   if (nameA > nameB) {
      //     return 1;
      //   }

      //   // names must be equal
      //   return 0;
      // });
      return resData;
    },
    //event table
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },
    async fn_handle(type, index, row){
      if(type == "save"){
        if(row.id){
          let data = {
            id: row.id,
            allow_dayoff_number: row.allow_dayoff_number,
            unallow_dayoff_number: row.unallow_dayoff_number,
            employee_id: row.employee_id,
            year: row.year,
          };
          try {
            await EmployeeDayOffApi.update(data);
            this.fn_initTable();
            this.mData.oldRowData = {
              allow_dayoff_number: data.allow_dayoff_number,
              unallow_dayoff_number: data.unallow_dayoff_number
            };
            window.toastr.success("Cập nhật ngày nghỉ phép nhân viên thành công!");
          } catch (error) {
            console.log(error);
            window.toastr.error("Cập nhật ngày nghỉ phép nhân viên thất bại!");
          }
        }else if(!row.id){
          let data = {
            allow_dayoff_number: row.allow_dayoff_number,
            unallow_dayoff_number: row.unallow_dayoff_number,
            year: row.year,
            company_id: row.company_id,
            employee_id: row.employee_id
          };
          try {
            await EmployeeDayOffApi.create(data);
            this.fn_initTable();
            this.mData.oldRowData = {
              allow_dayoff_number: data.allow_dayoff_number,
              unallow_dayoff_number: data.unallow_dayoff_number
            };
            window.toastr.success("Cập nhật ngày nghỉ phép nhân viên thành công!");
          } catch (error) {
            console.log(error);
            window.toastr.error("Cập nhật ngày nghỉ phép nhân viên thất bại!");
          }
        }
        this.mData.tableRules.data[index].showButtonUpdate = false;
      }
    },
    forceUpdateUI() {
      this.$forceUpdate();
    },
    focusInput(index, row){
      this.mData.tableRules.data[row.$index].showButtonUpdate = true;
      if(this.mData.previousRowClick != "null" && this.mData.previousRowClick != row.$index){
        this.mData.tableRules.data[this.mData.previousRowClick].showButtonUpdate = false;
        if(this.mData.oldRowData){
          if(this.mData.oldRowData.allow_dayoff_number != null || this.mData.oldRowData.allow_dayoff_number != 0){
            this.mData.tableRules.data[this.mData.previousRowClick].day_off.allow_dayoff_number = this.mData.oldRowData.allow_dayoff_number;
          }
          if(this.mData.oldRowData.unallow_dayoff_number != null || this.mData.oldRowData.unallow_dayoff_number != 0){
            this.mData.tableRules.data[this.mData.previousRowClick].day_off.unallow_dayoff_number = this.mData.oldRowData.unallow_dayoff_number;
          }
          this.mData.oldRowData = {};
        }
      }
      this.mData.previousRowClick = row.$index;

      if(this.mData.oldRowData && this.mData.oldRowData.index != index){
        this.mData.oldRowData.allow_dayoff_number = row.row.day_off.allow_dayoff_number;
        this.mData.oldRowData.unallow_dayoff_number = row.row.day_off.unallow_dayoff_number;
        this.mData.oldRowData.index = index;
      }
    },
    blurInput(index, row){
      if(this.mData.previousRowClick != row.$index){
        setTimeout(() => {
          this.mData.tableRules.data[row.$index].showButtonUpdate = false;
        },300)
      }
    }
  },

  //run after render view
  async created() {
    if (this.$route.query.year) {
      this.mData.dataForm.curentYear = this.$route.query.year;
      this.mData.tableRules.dataSearch.value.year = this.$route.query.year;
      this.mData.yearSelectSmallerThanCurrentYear =
        parseInt(this.$route.query.year) < new Date().getFullYear();
    } else {
      this.mData.dataForm.curentYear = new Date().getFullYear().toString();
      this.mData.tableRules.dataSearch.value.year = this.mData.dataForm.curentYear;
    }
    if (this.$route.query.employee_no) {
      this.mData.tableRules.dataSearch.value.employee_no =
        this.$route.query.employee_no;
    }
    if (this.$route.query.company_id) {
      this.mData.tableRules.dataSearch.value.company_id =
        this.$route.query.company_id;
    }
    if (this.$route.query.full_name) {
      this.mData.tableRules.dataSearch.value["administrative_info.name.full_name"] =
        this.$route.query.full_name;
    }
    if (this.$route.query.department_id) {
      this.mData.tableRules.dataSearch.value["job_info.department_id"] =
        this.$route.query.department_id;
    }
    if (this.$route.query.position_id) {
      this.mData.tableRules.dataSearch.value["job_info.position_id"] =
        this.$route.query.position_id;
    }
    if (this.$route.query.condition) {
      this.mData.tableRules.dataSearch.value.condition =
        this.$route.query.condition;
    }
    if (this.$route.query.allow_dayoff_number !== undefined) {
      this.mData.tableRules.dataSearch.value.allow_dayoff_number = Number(
        this.$route.query.allow_dayoff_number
      );
    }
    if (this.$route.query.unallow_dayoff_number !== undefined) {
      this.mData.tableRules.dataSearch.value.unallow_dayoff_number = Number(
        this.$route.query.unallow_dayoff_number
      );
    }
    if (this.$route.query.showFormSearch == "true") {
      this.mData.tableRules.showFormSearch = true;
    }
    if (this.$route.query.showFormSearch == "false") {
      this.mData.tableRules.showFormSearch = false;
    }
    this.fn_updateTableHeight();
    await this.fn_initDataDefault();
    this.fn_initTable();
  },
  mounted() {
    window.addEventListener("resize", this.fn_updateTableHeight);
    this.$nextTick(() => {
      this.fn_updateTableHeight();
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.fn_updateTableHeight);
  },
};
</script>
<style scoped>
.d-flex{
  justify-content: flex-start;
  align-items: center;
}
.d-flex .header-title{
  margin-right: 24px;
}
.year-toolbar-wrap{
  margin-right: 16px;
}
.header-actions{
  margin-left: auto;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 12px;
}
.header-search-toggle{
  margin: 0;
}
.header-policy-btn{
  margin: 0;
}
.year-toolbar{
  margin-bottom: 0;
}
.main-body-search{
  margin-bottom: 16px;
}
.scroll-css{
  box-sizing: border-box;
  padding-bottom: 0;
  overflow-y: visible !important;
  max-height: none !important;
}
.table-footer-actions{
  align-items: center;
  row-gap: 10px;
}
.pagination-action-row{
  order: 1;
}
.leave-history-action-row{
  order: 2;
  margin-top: 8px;
}
.leave-history-btn{
  min-width: 150px;
}
::v-deep .leave-deduction-history-dialog .el-dialog__body{
  padding-top: 12px;
}
.leave-history-filter-bar{
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
  width: 100%;
}
.leave-history-date-group{
  display: flex;
  gap: 12px;
  flex: 0 0 auto;
}
.leave-history-date-filter{
  width: 280px !important;
}
.leave-history-keyword-filter{
  min-width: 240px;
  width: 100%;
  max-width: none;
  flex: 1 1 auto;
}
::v-deep .leave-deduction-history-dialog .leave-history-date-filter.el-date-editor{
  width: 280px !important;
}
::v-deep .leave-deduction-history-dialog .leave-history-keyword-filter.el-input{
  width: 100%;
}
::v-deep .main-body-search .b-card{
  border: none;
  box-shadow: 0 8px 24px rgba(33, 37, 41, 0.08);
}
::v-deep .main-body-search .card-body{
  padding: 20px 24px 10px;
}
.search-form{
  width: 100%;
}
.search-grid{
  row-gap: 8px;
}
.search-actions{
  display: grid;
  grid-template-columns: minmax(0, 1fr) 108px;
  align-items: center;
  width: 100%;
  column-gap: 16px;
  margin-bottom: 0;
  padding-left: 16px;
  padding-right: 16px;
}
.condition-search{
  display: grid;
  grid-template-columns: 160px minmax(0, 1fr);
  align-items: center;
  gap: 0;
}
.condition-search__label{
  margin-bottom: 0;
  font-weight: 400;
  width: 160px;
  padding-right: 12px;
  text-align: left;
  white-space: nowrap;
}
::v-deep .condition-search .el-input{
  width: 100%;
  min-width: 0;
}
.search-button-wrap,
::v-deep .search-actions .el-button{
  width: 100%;
}
::v-deep .search-form .el-form-item{
  margin-bottom: 14px;
}
::v-deep .search-form .el-form-item__label{
  line-height: 50px;
  padding-bottom: 0;
  padding-right: 12px;
  margin-top: 0;
  text-align: left;
  white-space: nowrap;
}
::v-deep .search-form .el-form-item__content{
  display: flex;
  align-items: center;
  min-height: 50px;
}
::v-deep .annual-leave-policy-dialog .el-dialog__body{
  padding-top: 12px;
}
.policy-form__hint{
  color: #7c7c7c;
  margin-bottom: 16px;
}
::v-deep .annual-leave-policy-dialog .policy-el-form .el-form-item{
  margin-bottom: 14px;
}
::v-deep .policy-el-form .el-form-item__label{
  text-align: left;
  line-height: 40px;
  white-space: nowrap;
  margin-top: 0;
  padding-right: 16px;
}
::v-deep .policy-el-form .el-form-item__content{
  line-height: 40px;
  min-width: 0;
}
::v-deep .annual-leave-policy-dialog .policy-field,
::v-deep .annual-leave-policy-dialog .policy-field.el-date-editor,
::v-deep .annual-leave-policy-dialog .policy-field.el-input-number,
::v-deep .annual-leave-policy-dialog .policy-field.el-select{
  width: 100% !important;
  max-width: none;
}
::v-deep .annual-leave-policy-dialog .policy-field .el-input{
  width: 100%;
}
::v-deep .annual-leave-policy-dialog .policy-field.el-input-number .el-input-number__decrease,
::v-deep .annual-leave-policy-dialog .policy-field.el-input-number .el-input-number__increase{
  top: 1px;
  bottom: 1px;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1 !important;
  box-sizing: border-box;
}
::v-deep .annual-leave-policy-dialog .policy-field.el-input-number .el-input-number__decrease [class*="el-icon"],
::v-deep .annual-leave-policy-dialog .policy-field.el-input-number .el-input-number__increase [class*="el-icon"]{
  line-height: 1;
  margin: 0;
}
::v-deep .search-form .el-input,
::v-deep .search-form .el-select,
::v-deep .search-form .el-input-number{
  width: 100%;
}
::v-deep .search-form .el-input__inner,
::v-deep .search-form .el-select .el-input__inner,
::v-deep .search-form .el-input-number,
::v-deep .search-form .el-input-number .el-input__inner{
  height: 50px;
}
::v-deep .search-form .el-input-number{
  width: 100%;
}
::v-deep .search-form .el-input-number .el-input input{
  text-align: center;
}
::v-deep .year-toolbar .el-form-item__content{
  margin-left: 0 !important;
}
::v-deep .year-toolbar .el-form-item{
  margin-bottom: 0;
}
::v-deep .year-toolbar .el-form-item__label{
  margin-top: 0;
  padding-right: 8px;
}
::v-deep ::-webkit-scrollbar{
  height: 15px;
}
::v-deep .el-table__body-wrappe ::-webkit-scrollbar {
  width: 15px;
}
::v-deep .el-table__body-wrapper{
  padding-bottom: 10px;
}
::v-deep .el-date-editor{
  width: 91px;
}
::v-deep .el-form-item{
  margin-bottom: 0;
}
::v-deep .fake_p .el-input input{
  border-color: transparent;
  background-color: transparent;
  box-shadow: none;
}
::v-deep .fake_p .el-input input:hover{
  border-color: #C0C4CC;
  background-color: #fff;
}
::v-deep .fake_p .el-input input:focus{
  border-color: rgba(250, 164, 4, 0.5);
  background-color: #fff;
  box-shadow: none;
}
.remaining-dayoff-value{
  font-family: UTM Avo;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
}
::v-deep .year .el-input__inner{
  box-shadow: none;
  width: 100px;
  padding-right: 10px;
}
::v-deep .el-form-item__label{
  margin-top: 5px;
}
@media (max-width: 1200px){
  .d-flex{
    flex-wrap: wrap;
  }
  .year-toolbar-wrap{
    margin-right: 0;
  }
  .header-actions{
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-top: 12px;
    flex-wrap: wrap;
  }
}
@media (max-width: 768px){
  .leave-history-filter-bar{
    flex-wrap: wrap;
  }
  .leave-history-date-group,
  .leave-history-keyword-filter{
    width: 100%;
    flex: 1 1 100%;
    max-width: none;
  }
  .leave-history-date-group{
    flex-wrap: wrap;
  }
  .leave-history-date-filter{
    width: 100% !important;
    flex: 1 1 100%;
  }
  ::v-deep .leave-deduction-history-dialog .leave-history-date-filter.el-date-editor,
  ::v-deep .leave-deduction-history-dialog .leave-history-keyword-filter.el-input{
    width: 100% !important;
  }
  ::v-deep .main-body-search .card-body{
    padding: 16px 16px 8px;
  }
  ::v-deep .search-form .el-form-item__label{
    line-height: 22px;
    padding-bottom: 8px;
  }
  ::v-deep .search-form .el-form-item__content{
    display: block;
    min-height: auto;
  }
  .search-actions{
    display: block;
  }
  .search-actions{
    grid-template-columns: 1fr;
    row-gap: 12px;
  }
  .condition-search{
    width: 100%;
    grid-template-columns: 1fr;
    row-gap: 8px;
  }
  .condition-search__label{
    width: auto;
    padding-right: 0;
  }
  .policy-field{
    width: 100%;
  }
  ::v-deep .annual-leave-policy-dialog .policy-el-form .el-form-item__label{
    width: 100% !important;
    float: none;
    line-height: 24px;
    padding: 0 0 8px;
  }
  ::v-deep .annual-leave-policy-dialog .policy-el-form .el-form-item__content{
    margin-left: 0 !important;
  }
}
</style>
